<script lang="ts" setup>
  import StyleGuide from "frontend/components/StyleGuide.vue";
</script>

<template>
  <div class="vue-route__styleguide--index">
    <StyleGuide />
  </div>
</template>
